import {
  doStorySearch,
  hideStoryListLoading,
  showStoryListLoading,
  updateStoryList,
  updateStoryListFilters,
  resetSearch,
} from './storylist.actions';
import { Action } from 'redux';
import * as Immutable from 'seamless-immutable';
import { ImmutableObject } from 'seamless-immutable';
import { isType } from 'typescript-fsa';
import { LOCATION_CHANGE } from 'react-router-redux';
import { Pagination } from '../../components/Pagination/index';
import { AppState } from '../reducers';
import { getStoriesByIds, Story } from '../Entities/Stories/stories.reducer';
import { getClustersByIds } from '../Entities/Clusters/clusters.reducer';
import { getQueryParameter } from '../../utils/url';
import * as R from 'ramda';

export interface AvailableFilter {
  title: string;
  key: string;
}

export const AVAILABLE_FILTERS = [
  {
    title: 'Only Live',
    key: 'live',
  },
  {
    title: 'Only Boosted',
    key: 'boosted',
  },
  {
    title: 'Approved',
    key: 'active',
  },
  {
    title: 'Not approved',
    key: 'inactive',
  },
];

export interface StoryListFilters {
  [key: string]: boolean | string;
}

interface StoryList {
  loading: boolean;
  storyIds: number[];
  pagination?: Pagination;
  searchQuery?: string;
  country: string | undefined;
  filters: StoryListFilters;
}
export type StoryListState = StoryList & ImmutableObject<StoryList>;

const initialState = Immutable.from<StoryList>({
  storyIds: [],
  country: void 0,
  loading: true,
  filters: {
    live: false,
    boosted: false,
    active: false,
  },
});

export interface StoryResult {
  entities: {
    story: object;
  };
  result: {
    meta: object;
    data: object;
  };
}

export default function reduce(
  state: StoryListState = initialState,
  action: Action
) {
  if (isType(action, updateStoryList)) {
    const { storyIds, pagination } = action.payload;

    return state.merge({
      storyIds,
      pagination,
    });
  }

  if (isType(action, doStorySearch)) {
    const { query } = action.payload;
    return state.merge({
      searchQuery: query,
      pagination: {} as Pagination,
    });
  }

  if (isType(action, showStoryListLoading)) {
    return state.merge({
      loading: true,
    });
  }

  if (isType(action, hideStoryListLoading)) {
    return state.merge({
      loading: false,
    });
  }

  if (isType(action, updateStoryListFilters)) {
    const {
      payload: { filters },
    } = action;
    return state.merge({
      filters,
    });
  }

  if (isType(action, resetSearch)) {
    return state.merge({
      searchQuery: undefined,
    });
  }

  if (action.type === LOCATION_CHANGE) {
    const { search, pathname } = (action as any).payload;
    if (pathname !== '/stories') {
      return state;
    }

    return state.merge({
      pagination: {
        ...state.pagination,
        currentPage: getQueryParameter('page', search, 1),
      },
      searchQuery: getQueryParameter(
        'filter[search]',
        search,
        state.searchQuery
      ),
      country: getQueryParameter('country', search, state.country),
    });
  }

  return state;
}

export function getCountry(state: AppState) {
  const {
    storyList: { country },
  } = state;

  return country;
}

export function getStories(state: AppState): Story[] {
  const {
    storyList: { storyIds },
  } = state;
  return getStoriesByIds(state, storyIds).map((story: Story) => {
    return {
      ...story,
      clusters: story && getClustersByIds(state, story.clusters as number[]),
    };
  });
}

export function getPagination(state: AppState) {
  const {
    storyList: { pagination },
  } = state as any;
  return pagination;
}

export function getSearchQuery(state: AppState) {
  const {
    storyList: { searchQuery },
  } = state;
  return searchQuery;
}

export function getStoryListLoading(state: AppState) {
  const {
    storyList: { loading },
  } = state;
  return loading;
}

export function getActiveFilterKeys(state: AppState) {
  const filters = getStoryListFilters(state);
  return R.keys(R.pickBy((filterVal: boolean) => filterVal, filters as any));
}

export function getStoryListFilters(state: AppState) {
  const {
    storyList: { filters },
  } = state;
  return filters;
}

export function getStoryListActivePage(state: AppState): number {
  const {
    storyList: { pagination },
  } = state;

  return pagination && pagination.currentPage ? pagination.currentPage : 1;
}



// WEBPACK FOOTER //
// ./src/store/StoryList/storylist.reducer.ts